export class ListAppLoginRequest {
  constructor({ username = '', farmIds = [] } = {}) {
    this.username = username?.trim();
    this.farmIds = farmIds;
  }
}

export class AppLoginRequest {
  constructor({ username = '', password = '' } = {}) {
    this.username = username?.trim();
    this.password = password?.trim();
  }
}

export class DeleteDeviceRequest {
  constructor(codes = []) {
    this.codes = codes;
  }
}
